import { Component, OnInit, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SettingsService } from '../../services/service.index';

@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.css']
})
export class AccountSettingsComponent implements OnInit {

  classLast:any;

  constructor(@Inject(DOCUMENT) private _document, public _ajustes: SettingsService){ }

  ngOnInit(): void {
  }

  cambiarColor(event: any){


    if(event.srcElement.value==''){
      console.log(" vacio ");

          this._ajustes.aplicarTema('navbar navbar-fixed-top navbar-shadow');

    }else{


      console.log("Cambio de Color",event.srcElement.value);
            this._ajustes.aplicarTema(event.srcElement.value);
     /* this._document.getElementById('header').className = "navbar navbar-fixed-top navbar-shadow";
        this._document.getElementById('header').className += " "+event.srcElement.value;
        this.classLast = event.srcElement.value;*/


    }


  }

}
